import { createReducer, on } from '@ngrx/store';
import {
  COMPANY_DETAILS_TAB,
  COMPANY_TEMPLATE_ALLIANZ,
  COMPANY_TEMPLATE_GENERIC,
  CompanyState,
  companyUpdateCompanyValues,
  companyUpdateLobs,
  companyUpdateLogoFile,
  companyUpdateOriginalValues,
  companyUpdatePeriodRange,
  companyUpdatePeriods,
  companyUpdateSelectedCompany,
  companyUpdateSelectedLOBs,
  companyUpdateSelectedTab
} from '@cmi/store/admin/company';

export const companyInitialState = {
  selectedTab: COMPANY_DETAILS_TAB,
  lobs: [],
  periods: [],
  id: undefined,
  name: undefined,
  pdfCoverTitle: null,
  logoPath: null,
  template: null,
  startPeriodId: null,
  endPeriodId: null,
  isEnabled: false,
  logoFile: null,
  logoChanged: false,
  selectedLobs: null,
  originalValues: '',
  roleName: undefined
} as CompanyState;

export const companyReducer = createReducer(
  companyInitialState,
  on(companyUpdateSelectedTab, (state, prop) => ({ ...state, selectedTab: prop.selectedTab })),
  on(companyUpdateLobs, (state, prop) => ({ ...state, lobs: prop.lobs })),
  on(companyUpdatePeriods, (state, prop) => ({ ...state, periods: prop.periods })),
  on(companyUpdatePeriodRange, (state, prop) => ({
    ...state,
    startPeriodId: prop.startPeriodId,
    endPeriodId: prop.endPeriodId,
    isEnabled: prop.isEnabled
  })),
  on(companyUpdateSelectedCompany, (state, prop) => {
    let template: string | null = null;

    if (prop.company?.templateTypeId === 1) {
      template = COMPANY_TEMPLATE_ALLIANZ;
    }
    if (prop.company?.templateTypeId === 2) {
      template = COMPANY_TEMPLATE_GENERIC;
    }

    const name = prop.company?.name;
    const pdfCoverTitle = prop.company?.pdfCoverTitle ?? null;
    const logoPath = prop.company?.logoPath ?? null;
    const startPeriodId = prop.company?.startPeriodId
      ? prop.company?.startPeriodId.toString()
      : null;
    const endPeriodId = prop.company?.endPeriodId ? prop.company?.endPeriodId.toString() : null;
    const isEnabled = prop.company?.isEnabled ?? false;
    const selectedLobs =
      (prop.company?.companySubLobs ?? []).length > 0 ? (prop.company?.companySubLobs ?? []) : null;
    const roleName = prop.company?.roleName ?? undefined;
    return {
      ...state,
      lobs: [],
      periods: [],
      id: prop.company?.id,
      name,
      pdfCoverTitle,
      logoPath,
      logoFile: null,
      template,
      startPeriodId,
      endPeriodId,
      isEnabled,
      selectedLobs,
      originalValues: JSON.stringify({
        name,
        pdfCoverTitle,
        logoPath,
        template,
        startPeriodId,
        endPeriodId,
        isEnabled,
        selectedLobs: selectedLobs ?? []
      }),
      roleName
    };
  }),
  on(companyUpdateLogoFile, (state, prop) => ({
    ...state,
    logoPath: prop.logoFile ? prop.logoFile.name : null,
    logoFile: prop.logoFile
  })),
  on(companyUpdateCompanyValues, (state, prop) => {
    let periodFrom = (state.periods ?? []).find(
      (period) => period.id.toString() === prop.startPeriodId
    );
    let periodTo = (state.periods ?? []).find(
      (period) => period.id.toString() === prop.endPeriodId
    );

    if (periodFrom && periodTo && periodFrom.dateTo > periodTo.dateTo) {
      if (state.startPeriodId === prop.startPeriodId) {
        periodFrom = periodTo;
      } else {
        periodTo = periodFrom;
      }
    }

    return {
      ...state,
      name: prop.name ? prop.name : undefined,
      pdfCoverTitle: prop.pdfCoverTitle ? prop.pdfCoverTitle : null,
      logoPath: prop.logoFile ? prop.logoFile.name : null,
      logoFile: prop.logoFile ? prop.logoFile : null,
      template: prop.template ? prop.template : null,
      startPeriodId: periodFrom?.id ? periodFrom?.id.toString() : null,
      endPeriodId: periodTo?.id ? periodTo?.id.toString() : null,
      isEnabled: prop.status ?? false
    };
  }),
  on(companyUpdateOriginalValues, (state, prop) => ({
    ...state,
    id: prop.id,
    originalValues: JSON.stringify({
      name: state.name,
      pdfCoverTitle: state.pdfCoverTitle,
      logoPath: state.logoPath,
      template: state.template,
      startPeriodId: state.startPeriodId,
      endPeriodId: state.endPeriodId,
      isEnabled: state.isEnabled,
      selectedLobs: state.selectedLobs ?? []
    })
  })),
  on(companyUpdateSelectedLOBs, (state, prop) => ({
    ...state,
    selectedLobs: prop.selectedLobs
  }))
);
